import styled from "styled-components";

import { typography } from "globalConstants";
import { Default } from "Types";

export type PropsType = Default;

const Wrap = styled.div<Default>`
   border: 1px solid ${typography.other.color.gray[3]};
   border-radius: 6px;
   padding: 30px 40px;
   width: 439px;
   max-width: 100%;
   box-sizing: border-box;
   ${({ css }) => css}
`;

export default function Paper(props: PropsType) {
   return <Wrap {...props}>{props.children}</Wrap>;
}
